import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Outbound - the floor manager's product: task plans and tasks today, then
 * items, locations and the setup screens behind them.
 *
 * One product among several under an organisation, owning its own URL segment:
 * /orgs/{org}/outbound/... Warehouse scope lives inside here rather than in the
 * app shell, because it belongs to the products that need one - /outbound is a
 * door that picks one up, and every screen sits under /whs/{location} past it.
 *
 * This file claims the segment and nothing else. The shell - header, navigation
 * rail, warehouse reconciliation - belongs to the warehouse layout, since none
 * of it can be drawn before a warehouse is settled.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/outbound",
)({
  component: Outlet,
});
